const localeFromURL = function () {
  const available = ['en', 'fr']
  const found =
    available.find(x => x === document.location.pathname.split('/')[1])

  return found || 'en'
}

export { localeFromURL }
